import { Component, Input, OnInit } from '@angular/core';
import { saveAs } from 'file-saver';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { firstValueFrom } from 'rxjs';
import { DateFormatterService } from 'src/app/services/date-formatter.service';

@Component({
  selector: 'app-csv',
  templateUrl: './csv.component.html',
  styleUrls: ['./csv.component.scss']
})
export class CsvComponent implements OnInit {

  constructor(private firestore: AngularFirestore, private date: DateFormatterService) { }

  @Input() businessId!: string;
  users = [];

  async getUsers() {
    const userSnapshot: any = await firstValueFrom(
      this.firestore.collection('Users', ref => ref.where('followedBusinesses', 'array-contains', this.businessId)).get()
    );
    this.users = userSnapshot.docs.map((doc: any) => doc.data());
  }

  exportCSV() {
    // Convert JSON data to CSV string
    this.getUsers().then(() => {
      const csvData = this.convertToCSV(this.users);

      // Create Blob from the CSV data
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
  
      // Use FileSaver.js to trigger the download
      saveAs(blob, 'users-data.csv');
    }) 
  }

  // Function to convert JSON to CSV, replacing missing values with '/'
  private convertToCSV(data: any[]) {
    const headers = ['Email', 'Name', 'Child Name', 'Child Age', 'Child Gender', 'Child Bday'];

    const array = [headers].concat(data.map(user => {
      return [
        user.email || '/',
        user.name || '/',
        user.childInfo && user.childInfo[0] ? user.childInfo[0].name || '/' : '/',
        user.childInfo && user.childInfo[0] ? user.childInfo[0].age !== null ? user.childInfo[0].age : '/' : '/',
        user.childInfo && user.childInfo[0] ? user.childInfo[0].gender || '/' : '/',
        user.childInfo && user.childInfo[0] ? this.date.formatDate(user.childInfo[0].birthdayDate) || '/' : '/'
      ];
    }));

    // Create CSV rows
    return array.map(row => row.join(',')).join('\n');
  }

  ngOnInit(): void {
  }

}
